import Header from './Header';
import Footer from './Footer';
import BottomNav from './BottomNav';
import { CommandPalette } from './CommandPalette';

interface LayoutProps {
    children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    return (
        <div className="min-h-screen bg-background text-foreground flex flex-col font-sans selection:bg-primary/20 theme-transition">
            <Header />
            <CommandPalette />
            <main className="flex-grow pb-24 lg:pb-0">
                {children}
            </main>
            <BottomNav />
            <Footer />
        </div>
    );
}
